import styled from '@emotion/styled';

/**
 * A one-shot flash animation. It always plays start-to-finish and settles
 * back to transparent on its own, regardless of whatever triggered it (e.g.
 * selection state) ever changing back - no JS state toggle required.
 *
 * Mount it with a unique `key` (e.g. a token that changes per trigger) so the
 * browser replays the animation from scratch every time.
 */
const FlashOverlay = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  animation: articleItemFlash 1s ease;

  @keyframes articleItemFlash {
    0% {
      background-color: transparent;
    }
    25% {
      background-color: var(--colorUIYellow);
    }
    100% {
      background-color: transparent;
    }
  }
`;

export default FlashOverlay;
